import type { ContentBlock } from './seoBlogArticles'

// Blogartikelen voor ondernemers in Noord-Holland Noord.
// Losstaand van de SEO-kennisbank: dit zijn praktische stukken op de vraag
// die een ondernemer daadwerkelijk in Google typt. Elke post krijgt een
// eigen pagina op /blog/<slug>.

export type BlogCategory =
  | 'Online gevonden worden'
  | 'Websites'
  | 'Vormgeving'
  | 'Per branche'
  | 'Techniek en beheer'

export type BlogPost = {
  slug: string
  title: string
  category: BlogCategory
  excerpt: string
  metaDescription: string
  keywords: string
  readingTime: number
  content: ContentBlock[]
  relatedPosts: string[]
}

// Eén eigen beeld per artikel, op slug. Zo verschilt elke kaart in de
// bibliotheek en op de home van de rest.
export const postImages: Record<string, string> = {
  'wat-kost-een-website-laten-maken':
    'https://cdn.magicpatterns.com/patterns/generated-images/de4d5d35-48c7-4a31-8a04-a6c23380fd58.jpg',
  'google-bedrijfsprofiel-optimaliseren':
    'https://cdn.magicpatterns.com/patterns/generated-images/3a3b9779-15a5-4914-a1f0-fbaa463d6b85.jpg',
  'lokaal-gevonden-worden-noord-holland':
    'https://cdn.magicpatterns.com/patterns/generated-images/f5f5fc89-ccc6-4b60-b4dc-65eccf60681b.jpg',
  'reviews-vragen-aan-klanten':
    'https://cdn.magicpatterns.com/patterns/generated-images/7a7312e2-c90b-4764-917f-46d5664422a1.jpg',
  'waarom-word-ik-niet-gevonden-in-google':
    'https://cdn.magicpatterns.com/patterns/generated-images/9d97558b-95ee-4d56-b11b-f141f64bdafa.jpg',
  'website-laten-maken-of-zelf-doen':
    'https://cdn.magicpatterns.com/patterns/generated-images/8726136f-34cb-4311-9670-ce7fe6dfbf6f.jpg',
  'teksten-voor-je-website-schrijven':
    'https://cdn.magicpatterns.com/patterns/generated-images/3672eba0-d967-4611-a8e5-5e175e114dd8.jpg',
  'contactformulier-dat-aanvragen-oplevert':
    'https://cdn.magicpatterns.com/patterns/generated-images/67f20059-561b-41ff-8bf0-6f9faeafea05.jpg',
  'hoeveel-paginas-heeft-mijn-website-nodig':
    'https://cdn.magicpatterns.com/patterns/generated-images/fae699d2-2f6d-4c46-8d96-0f4b3841886a.jpg',
  'website-sneller-maken':
    'https://cdn.magicpatterns.com/patterns/generated-images/197c2b97-fccb-4556-bc08-f653cf826c9e.jpg',
  'logo-laten-ontwerpen-waar-let-je-op':
    'https://cdn.magicpatterns.com/patterns/generated-images/d86dd00d-073b-48e3-8dcc-3ebde624b65a.jpg',
  'huisstijl-in-figma-uitgelegd':
    'https://cdn.magicpatterns.com/patterns/generated-images/bb3ea500-eb56-418f-9eaa-3fb6e4c3e446.jpg',
  'visitekaartjes-die-blijven-liggen':
    'https://cdn.magicpatterns.com/patterns/generated-images/369dfbbc-9111-4eea-b249-e23b7a1bb235.jpg',
  'gevelreclame-en-bedrijfskleding':
    'https://cdn.magicpatterns.com/patterns/generated-images/7e545938-7fe7-4469-a889-a177c29ac93d.jpg',
  'website-fysiotherapiepraktijk-checklist':
    'https://cdn.magicpatterns.com/patterns/generated-images/cf78462c-c178-4c04-ad5b-787e0cff0053.jpg',
  'sportschool-meer-proeflessen':
    'https://cdn.magicpatterns.com/patterns/generated-images/6251635a-f0f7-42b6-80ab-f6bc9475d7da.jpg',
  'hovenier-projecten-laten-zien':
    'https://cdn.magicpatterns.com/patterns/generated-images/67c20106-d42a-499f-81c2-e0c7e0cc207e.jpg',
  'uitzendbureau-twee-doelgroepen':
    'https://cdn.magicpatterns.com/patterns/generated-images/29f0411c-f712-48d8-9c7b-313fa98a23c5.jpg',
  'zakelijke-email-op-je-eigen-domein':
    'https://cdn.magicpatterns.com/patterns/generated-images/7f751763-716f-4ef5-b284-a3892fceb8ed.jpg',
  'website-onderhoud-waarom-nodig':
    'https://cdn.magicpatterns.com/patterns/generated-images/85692041-5423-46c1-afa6-81e150bd5e3c.jpg',
}

// Valt terug op een beeld per onderwerp als een artikel nog geen eigen foto heeft.
export const categoryFallbackImages: Record<BlogCategory, string> = {
  'Online gevonden worden':
    'https://cdn.magicpatterns.com/patterns/generated-images/f5f5fc89-ccc6-4b60-b4dc-65eccf60681b.jpg',
  Websites:
    'https://cdn.magicpatterns.com/patterns/generated-images/8726136f-34cb-4311-9670-ce7fe6dfbf6f.jpg',
  Vormgeving:
    'https://cdn.magicpatterns.com/patterns/generated-images/d86dd00d-073b-48e3-8dcc-3ebde624b65a.jpg',
  'Per branche':
    'https://cdn.magicpatterns.com/patterns/generated-images/cf78462c-c178-4c04-ad5b-787e0cff0053.jpg',
  'Techniek en beheer':
    'https://cdn.magicpatterns.com/patterns/generated-images/85692041-5423-46c1-afa6-81e150bd5e3c.jpg',
}

export const blogPostsPart1: BlogPost[] = [
  {
    slug: 'wat-kost-een-website-laten-maken',
    title: 'Wat kost een website laten maken? Een eerlijk overzicht',
    category: 'Online gevonden worden',
    excerpt:
      'Waarom de ene bouwer 500 euro vraagt en de andere 8.000, en hoe je bepaalt wat jouw situatie nodig heeft.',
    metaDescription:
      'Wat kost een website laten maken in 2026? Een eerlijk overzicht van de prijsklassen, wat er wel en niet in zit, en welke keuze past bij een bedrijf met een tot tien medewerkers.',
    keywords:
      'wat kost een website, website laten maken prijs, kosten website mkb, website laten maken Noord-Holland',
    readingTime: 6,
    content: [
      {
        type: 'paragraph',
        content:
          'Het is de eerste vraag die vrijwel elke ondernemer stelt, en het eerlijke antwoord is onbevredigend: dat hangt ervan af. Niet omdat we vaag willen doen, maar omdat een onepager voor een zzp-hovenier en een praktijksite met veertien behandelpagina\u2019s twee volstrekt verschillende opdrachten zijn. Wat we wel kunnen doen is de prijsklassen uit elkaar trekken en vertellen wat er in elke klasse redelijk is om te verwachten.',
      },
      { type: 'heading', content: 'De vier prijsklassen' },
      {
        type: 'list',
        items: [
          'Tot 750 euro: een onepager. Eén pagina, je aanbod, je bewijs en een contactformulier. Prima startpunt als je nog geen site hebt en snel vindbaar wilt zijn op je eigen bedrijfsnaam.',
          '750 tot 2.500 euro: meerdere pagina\u2019s, een eigen pagina per dienst, eenvoudige teksten en een aanvraagformulier. Dit is de klasse waar de meeste bedrijven met een tot tien medewerkers thuishoren.',
          '2.500 tot 6.000 euro: uitgebreidere sites met veel pagina\u2019s, koppelingen met software, een vacaturemodule of een blog. Vaak inclusief teksten en fotografie.',
          'Boven 6.000 euro: maatwerk, webshops, portalen of complexe koppelingen. Hier gaat de meeste tijd naar techniek en niet naar vormgeving.',
        ],
      },
      { type: 'heading', content: 'Waar de prijs echt door bepaald wordt' },
      {
        type: 'paragraph',
        content:
          'Niet door het aantal pagina\u2019s, maar door het aantal beslissingen. Een site met tien pagina\u2019s waarvan de structuur en de teksten al vaststaan is goedkoper dan een site met vier pagina\u2019s waarbij nog niemand weet wat er moet staan. Daarom vragen we in het eerste gesprek zoveel naar je vak: hoe scherper de bedoeling, hoe lager de kosten.',
      },
      {
        type: 'callout',
        content:
          'Het duurste onderdeel van een website is bijna nooit de bouw. Het is het wachten op teksten en foto\u2019s.',
      },
      { type: 'heading3', content: 'Wat er los van komt' },
      {
        type: 'paragraph',
        content:
          'Reken naast de bouw op hosting en onderhoud als maandelijkse post, en op een domeinnaam per jaar. Dat is geen verdienmodel achteraf maar simpelweg wat het kost om een site online, veilig en actueel te houden. Vraag altijd of updates, back-ups en beveiliging erin zitten, want dat verschilt sterk per aanbieder.',
      },
      { type: 'heading', content: 'Wat een lage prijs vaak betekent' },
      {
        type: 'paragraph',
        content:
          'Een heel lage prijs is niet per definitie verkeerd, maar er zit altijd iets tegenover. Meestal is dat een standaard template zonder eigen structuur, teksten die je zelf moet aanleveren, of geen enkele aandacht voor vindbaarheid. Dat kan prima werken als je alleen een digitale visitekaart nodig hebt. Wil je dat de site klanten oplevert, dan komt dat werk later alsnog.',
      },
      {
        type: 'paragraph',
        content:
          'Onze eigen prijzen staan op de pagina over websites, en met de prijsscan krijg je in een paar minuten een indicatie voor jouw situatie. Geen verkooppraat, gewoon een richtbedrag om mee te rekenen.',
      },
    ],
    relatedPosts: [
      'website-laten-maken-of-zelf-doen',
      'hoeveel-paginas-heeft-mijn-website-nodig',
      'website-onderhoud-waarom-nodig',
    ],
  },
  {
    slug: 'google-bedrijfsprofiel-optimaliseren',
    title: 'Google Bedrijfsprofiel optimaliseren: negen punten die tellen',
    category: 'Online gevonden worden',
    excerpt:
      'Voor lokale bedrijven levert je bedrijfsprofiel vaak sneller aanvragen op dan je website. Dit zet je goed.',
    metaDescription:
      'Je Google Bedrijfsprofiel is voor lokale bedrijven vaak de eerste indruk. Negen concrete punten om het profiel compleet te maken en beter in de kaartresultaten te komen.',
    keywords:
      'google bedrijfsprofiel optimaliseren, google mijn bedrijf, lokaal gevonden worden, kaartresultaten google',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Zoekt iemand op fysiotherapie in de buurt of hovenier Alkmaar, dan staan de drie kaartresultaten bovenaan. Die plekken worden niet door je website bepaald maar door je Google Bedrijfsprofiel. Het is gratis, het kost een uur werk en het levert voor lokale bedrijven vaak sneller aanvragen op dan welke andere maatregel.',
      },
      { type: 'heading', content: 'De negen punten' },
      {
        type: 'list',
        items: [
          'Vul de juiste hoofdcategorie in. Dit is de belangrijkste knop van je hele profiel. Kies de categorie die precies je vak beschrijft, niet de ruimste.',
          'Voeg subcategorieën toe voor je specialisaties, maar niet meer dan er echt bij passen.',
          'Zet je openingstijden erin, inclusief afwijkende tijden rond feestdagen.',
          'Gebruik een telefoonnummer dat ook echt wordt opgenomen, en hetzelfde nummer als op je website.',
          'Link naar de meest relevante pagina, niet altijd naar de homepage. Een fysiotherapiepraktijk kan beter naar de behandelpagina linken.',
          'Zet minimaal tien echte foto\u2019s van je pand, je team en je werk. Geen stockfoto\u2019s, mensen zien dat.',
          'Beschrijf je diensten in de dienstenlijst, met de woorden die klanten gebruiken.',
          'Vraag consequent om reviews en reageer op alle reviews, ook de minder leuke.',
          'Plaats af en toe een update. Het profiel dat leeft, doet het beter dan het profiel dat stilstaat.',
        ],
      },
      { type: 'heading', content: 'Waarom consistentie zoveel uitmaakt' },
      {
        type: 'paragraph',
        content:
          'Google vergelijkt je naam, adres en telefoonnummer met wat er elders over je bedrijf staat, op je site, in bedrijvengidsen en op branchepagina\u2019s. Staat het overal net anders, dan wordt Google voorzichtig. Kies één schrijfwijze en houd die overal aan, tot en met de spelling van je straatnaam.',
      },
      {
        type: 'callout',
        content:
          'Een compleet profiel met dertig reviews verslaat een half ingevuld profiel met vijf reviews, ook als dat tweede bedrijf beter is.',
      },
      { type: 'heading3', content: 'Wat je website er nog aan toevoegt' },
      {
        type: 'paragraph',
        content:
          'Het profiel brengt je in de kaart, je website bepaalt of iemand daadwerkelijk belt. Zorg dus dat de pagina waar je naar linkt hetzelfde belooft als je profiel, met dezelfde openingstijden en hetzelfde nummer. Vermeld je vestigingsplaats in de tekst, want dat helpt Google om je aan de regio te verbinden.',
      },
    ],
    relatedPosts: [
      'lokaal-gevonden-worden-noord-holland',
      'reviews-vragen-aan-klanten',
      'waarom-word-ik-niet-gevonden-in-google',
    ],
  },
  {
    slug: 'lokaal-gevonden-worden-noord-holland',
    title: 'Lokaal gevonden worden in Noord-Holland Noord: waar begin je?',
    category: 'Online gevonden worden',
    excerpt:
      'In een regio met beperkte concurrentie is de eerste plek dichterbij dan je denkt. Dit is de volgorde die werkt.',
    metaDescription:
      'Beter gevonden worden in Dijk en Waard, Alkmaar, Schagen of Hoorn? De volgorde waarin je lokale vindbaarheid aanpakt, van bedrijfsprofiel tot pagina per plaats.',
    keywords:
      'lokaal gevonden worden, local seo Noord-Holland, seo Alkmaar, vindbaar in Dijk en Waard',
    readingTime: 6,
    content: [
      {
        type: 'paragraph',
        content:
          'In grote steden vechten tientallen bedrijven om dezelfde zoekwoorden. In Noord-Holland Noord is dat vaak anders. Op veel termen staan drie of vier bedrijven waarvan er twee een verwaarloosde website hebben. Dat betekent dat de eerste plek hier binnen bereik ligt met werk dat elders niet genoeg zou zijn.',
      },
      { type: 'heading', content: 'Stap één: de basis kloppend maken' },
      {
        type: 'paragraph',
        content:
          'Begin bij je Google Bedrijfsprofiel en bij je naam, adres en telefoonnummer. Zorg dat die overal identiek zijn. Dit is het minst spannende werk en het levert het meeste op, juist omdat de meeste concurrenten het half hebben gedaan.',
      },
      { type: 'heading', content: 'Stap twee: een pagina per dienst' },
      {
        type: 'paragraph',
        content:
          'Eén pagina waarop al je diensten onder elkaar staan rankt nergens goed op. Iemand die zoekt op dry needling of op tuinonderhoud wil op een pagina landen die daarover gaat. Geef elke dienst waar je serieus werk uit wilt halen een eigen pagina, met de vraag van de klant als kop.',
      },
      { type: 'heading', content: 'Stap drie: de plaatsnaam op de juiste plek' },
      {
        type: 'paragraph',
        content:
          'Noem je vestigingsplaats en je werkgebied in gewone zinnen op je pagina\u2019s, in je titel en in je contactgegevens. Werk je in meerdere plaatsen, dan kan een eigen pagina per plaats zinvol zijn, maar alleen als daar echt iets anders te vertellen valt. Tien vrijwel identieke plaatspagina\u2019s doen meer kwaad dan goed.',
      },
      {
        type: 'callout',
        content:
          'Vindbaarheid in de regio is zelden een kwestie van slimme trucs. Het is de saaie dingen wel doen.',
      },
      { type: 'heading3', content: 'Wat je van reviews mag verwachten' },
      {
        type: 'paragraph',
        content:
          'Reviews wegen in de kaartresultaten zwaar, en in kleinere plaatsen zwaarder dan je denkt. Twintig recente reviews met een 4,8 gemiddeld zetten je vaak boven een concurrent met meer ervaring maar zonder beoordelingen. Vraag er structureel om, niet één keer per jaar in een actie.',
      },
      { type: 'heading', content: 'Hoe lang het duurt' },
      {
        type: 'paragraph',
        content:
          'Op lokale zoekopdrachten zie je meestal binnen twee tot drie maanden beweging. Op bredere termen duurt het langer, soms een half jaar of meer. Wie belooft dat je binnen een maand bovenaan staat, verkoopt je iets dat niet bestaat.',
      },
    ],
    relatedPosts: [
      'google-bedrijfsprofiel-optimaliseren',
      'waarom-word-ik-niet-gevonden-in-google',
      'reviews-vragen-aan-klanten',
    ],
  },
  {
    slug: 'reviews-vragen-aan-klanten',
    title: 'Reviews vragen aan klanten zonder dat het ongemakkelijk wordt',
    category: 'Online gevonden worden',
    excerpt:
      'De meeste klanten willen best een review schrijven. Ze moeten alleen op het juiste moment gevraagd worden.',
    metaDescription:
      'Hoe vraag je klanten om een Google-review zonder opdringerig te zijn? Het juiste moment, de juiste vraag en wat je doet met een minder positieve beoordeling.',
    keywords:
      'reviews vragen, google reviews krijgen, beoordelingen klanten, review vragen voorbeeld',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Veel ondernemers vinden om een review vragen ongemakkelijk. Het voelt als bedelen om een compliment. In de praktijk is het simpeler: klanten die tevreden zijn helpen graag, maar ze denken er zelf niet aan. Het enige wat je hoeft te doen is het vragen op het moment dat de tevredenheid het hoogst is.',
      },
      { type: 'heading', content: 'Het juiste moment' },
      {
        type: 'paragraph',
        content:
          'Dat is niet bij de factuur en niet weken later. Het is het moment waarop de klant zelf zegt dat hij blij is. Bij een hovenier is dat als de tuin net is opgeleverd. Bij een fysiotherapiepraktijk is dat de laatste behandeling. Bij een schoonmaakbedrijf na de eerste maand. Leg dat moment vast in je proces, zodat het niet van je stemming afhangt.',
      },
      { type: 'heading', content: 'Hoe je het vraagt' },
      {
        type: 'list',
        items: [
          'Vraag persoonlijk, niet via een massamail. Een appje van de persoon die het werk deed doet het beduidend beter.',
          'Stuur de directe link naar je reviewformulier mee. Elke extra klik kost je de helft van de reacties.',
          'Geef een aanknopingspunt: vraag waar hij het meest tevreden over was. Een lege pagina is een drempel.',
          'Vraag nooit om een cijfer of een bepaalde formulering. Dat is tegen de regels en het is te zien.',
        ],
      },
      {
        type: 'callout',
        content:
          'Twintig recente reviews wegen zwaarder dan honderd reviews uit 2019. Actualiteit telt mee.',
      },
      { type: 'heading', content: 'En als iemand kritisch is' },
      {
        type: 'paragraph',
        content:
          'Een enkele kritische review is geen probleem, die maakt de rest juist geloofwaardig. Wat wel telt is je reactie. Reageer rustig, zonder in discussie te gaan, benoem wat je anders zou doen en bied aan het buiten de review op te lossen. Toekomstige klanten lezen vooral hoe je met kritiek omgaat.',
      },
      {
        type: 'paragraph',
        content:
          'Zet je beste reviews daarna ook op je eigen website, met naam en plaats erbij. Op je site zijn ze het bewijs dat iemand zoekt voordat hij het formulier invult.',
      },
    ],
    relatedPosts: [
      'google-bedrijfsprofiel-optimaliseren',
      'lokaal-gevonden-worden-noord-holland',
      'contactformulier-dat-aanvragen-oplevert',
    ],
  },
  {
    slug: 'waarom-word-ik-niet-gevonden-in-google',
    title: 'Waarom word ik niet gevonden in Google? Zeven oorzaken',
    category: 'Online gevonden worden',
    excerpt:
      'Je hebt een nette website, en toch komt er niemand. In bijna alle gevallen is het een van deze zeven dingen.',
    metaDescription:
      'Je website staat online maar levert niets op. Zeven veelvoorkomende oorzaken waarom een bedrijf niet gevonden wordt in Google, en wat je er per oorzaak aan doet.',
    keywords:
      'niet gevonden in google, website wordt niet gevonden, waarom geen bezoekers website, seo problemen',
    readingTime: 7,
    content: [
      {
        type: 'paragraph',
        content:
          'Een nette website die niets oplevert is frustrerend, juist omdat je niet ziet waar het aan schort. In de praktijk komen we bijna altijd op dezelfde zeven oorzaken uit. Loop ze langs voordat je iemand inhuurt om er iets aan te doen.',
      },
      { type: 'heading', content: '1. Je site gaat over jezelf' },
      {
        type: 'paragraph',
        content:
          'Op veel sites staat wie het bedrijf is en sinds wanneer. Niemand zoekt daarop. Mensen zoeken op hun probleem: een lekkende kraan, pijn in de knie, personeel voor de zomerpiek. Staan die woorden niet op je site, dan is er niets om te vinden.',
      },
      { type: 'heading', content: '2. Alles staat op één pagina' },
      {
        type: 'paragraph',
        content:
          'Een pagina kan maar één onderwerp goed dekken. Zes diensten op één pagina betekent zes onderwerpen die elkaar verdringen. Geef ze elk een eigen pagina.',
      },
      { type: 'heading', content: '3. Je vestigingsplaats staat er nergens' },
      {
        type: 'paragraph',
        content:
          'Zonder plaatsnaam kan Google je niet aan een regio verbinden, en juist die regio is voor lokale bedrijven het hele verhaal. Zet je plaats in je titels, in je teksten en in je contactgegevens.',
      },
      { type: 'heading', content: '4. Je site is te traag' },
      {
        type: 'paragraph',
        content:
          'Duurt het langer dan drie seconden voordat er iets zichtbaar is, dan haakt een groot deel van je bezoekers af. Meestal komt het door foto\u2019s die veel te groot zijn geëxporteerd.',
      },
      { type: 'heading', content: '5. Er is niets te doen op de pagina' },
      {
        type: 'paragraph',
        content:
          'Geen duidelijke vervolgstap betekent geen aanvragen, ook bij goed bezoek. Eén heldere actie per pagina is genoeg, mits die opvalt.',
      },
      { type: 'heading', content: '6. Je profiel is niet op orde' },
      {
        type: 'paragraph',
        content:
          'Voor lokale zoekopdrachten telt je Google Bedrijfsprofiel vaak zwaarder dan je website. Een half ingevuld profiel kost je de kaartresultaten.',
      },
      { type: 'heading', content: '7. Je hebt nog niet lang genoeg gewacht' },
      {
        type: 'paragraph',
        content:
          'Soms is er niets mis en is de site simpelweg drie weken oud. Google heeft tijd nodig om nieuwe pagina\u2019s te wegen. Reken op twee tot drie maanden voordat je op lokale termen beweging ziet.',
      },
      {
        type: 'callout',
        content:
          'Vraag bij elke pagina op je site: welke vraag beantwoordt deze, en van wie? Kun je dat niet zeggen, dan kan Google het ook niet.',
      },
    ],
    relatedPosts: [
      'lokaal-gevonden-worden-noord-holland',
      'website-sneller-maken',
      'teksten-voor-je-website-schrijven',
    ],
  },
  {
    slug: 'website-laten-maken-of-zelf-doen',
    title: 'Website laten maken of zelf doen? Een eerlijke afweging',
    category: 'Websites',
    excerpt:
      'Zelf bouwen kan uitstekend werken. Maar niet in elke situatie, en zelden zo goedkoop als het lijkt.',
    metaDescription:
      'Zelf een website bouwen of laten maken? Een eerlijke afweging van kosten, tijd en risico voor ondernemers met een tot tien medewerkers.',
    keywords:
      'zelf website maken of laten maken, website bouwen zzp, wordpress zelf doen, website uitbesteden',
    readingTime: 6,
    content: [
      {
        type: 'paragraph',
        content:
          'We zeggen dit als bureau dat er geld aan verdient: soms is zelf doen de betere keuze. Als je net begint, je aanbod nog verandert en je vooral een plek nodig hebt waar mensen je gegevens vinden, dan bouw je dat prima zelf in een middag.',
      },
      { type: 'heading', content: 'Wanneer zelf doen goed werkt' },
      {
        type: 'list',
        items: [
          'Je bent net gestart en je aanbod staat nog niet vast.',
          'Je klanten komen nu vooral via via en de site is een visitekaart.',
          'Je vindt het leuk en je hebt de avonden ervoor.',
          'Je hebt één dienst en één doelgroep, dus één pagina volstaat.',
        ],
      },
      { type: 'heading', content: 'Wanneer het je duurder uitkomt' },
      {
        type: 'paragraph',
        content:
          'Het kantelt zodra de site werk moet opleveren. Structuur bedenken die op zoekvragen aansluit, teksten schrijven die verkopen zonder te schreeuwen, een formulier dat aankomt in je mail en niet in spam, foto\u2019s die snel laden: dat is het werk waar de tijd in gaat zitten. Reken bij zelf doen op dertig tot vijftig uur voor een serieuze site. Dat zijn uren die je niet aan je vak besteedt.',
      },
      {
        type: 'callout',
        content:
          'De vraag is niet of je een website kunt maken. De vraag is of jouw uur beter in je eigen vak zit.',
      },
      { type: 'heading3', content: 'De tussenvorm die vaak past' },
      {
        type: 'paragraph',
        content:
          'Wij bouwen de structuur, de vormgeving en de vindbaarheid, en jij beheert daarna zelf de teksten en foto\u2019s. Dat is voor de meeste bedrijven de verstandigste verdeling: het lastige werk eenmalig goed, het bijhouden in eigen hand. Daarom leveren we in WordPress op en geven we bij oplevering uitleg.',
      },
      { type: 'heading', content: 'Waar je bij zelf doen op moet letten' },
      {
        type: 'paragraph',
        content:
          'Zet je domeinnaam altijd op je eigen naam, ook als iemand anders het regelt. Kies een hostingpartij die back-ups maakt. En exporteer je foto\u2019s op de juiste maat, want dat is de meest voorkomende reden dat een zelfgebouwde site traag is.',
      },
    ],
    relatedPosts: [
      'wat-kost-een-website-laten-maken',
      'hoeveel-paginas-heeft-mijn-website-nodig',
      'website-sneller-maken',
    ],
  },
  {
    slug: 'teksten-voor-je-website-schrijven',
    title: 'Teksten voor je website schrijven: begin bij de vraag',
    category: 'Websites',
    excerpt:
      'De meeste websiteteksten beginnen bij het bedrijf. Dat is precies de verkeerde kant.',
    metaDescription:
      'Praktische uitleg over het schrijven van websiteteksten die klanten en Google helpen: begin bij de vraag van de klant, schrijf zoals je praat en houd het concreet.',
    keywords:
      'websiteteksten schrijven, teksten voor website, seo teksten, copywriting mkb',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Vraag een ondernemer om websiteteksten en er komt bijna altijd een stuk over het bedrijf: opgericht in, gevestigd in, gespecialiseerd in. Begrijpelijk, maar niemand zoekt daarop. Je bezoeker heeft een vraag en wil weten of jij die kunt beantwoorden.',
      },
      { type: 'heading', content: 'Begin bij de eerste vraag' },
      {
        type: 'paragraph',
        content:
          'Schrijf op wat de vijf vragen zijn die je in een eerste gesprek altijd krijgt. Dat zijn je koppen. Onder elke kop komt het antwoord dat je normaal mondeling geeft. Zo ontstaat een tekst die klopt met hoe mensen zoeken, zonder dat je iets van SEO hoeft te weten.',
      },
      { type: 'heading', content: 'Vijf regels die het meeste verschil maken' },
      {
        type: 'list',
        items: [
          'Schrijf zoals je praat. Lees het hardop terug, struikel je, herschrijf het.',
          'Wees concreet. Niet kwaliteit staat bij ons hoog in het vaandel, maar wij komen binnen twee werkdagen langs.',
          'Noem je vestigingsplaats en werkgebied in gewone zinnen, niet als opsomming van dertig dorpen.',
          'Zet het belangrijkste bovenaan. Bijna niemand leest tot onderaan.',
          'Eén duidelijke vervolgstap per pagina. Bellen of het formulier, niet vijf keuzes.',
        ],
      },
      {
        type: 'callout',
        content:
          'Woorden die je zelf nooit tegen een klant zou zeggen, horen ook niet op je website.',
      },
      { type: 'heading3', content: 'Hoe lang moet een pagina zijn?' },
      {
        type: 'paragraph',
        content:
          'Lang genoeg om de vraag echt te beantwoorden, niet langer. Voor een dienstpagina is drie- tot zeshonderd woorden vaak genoeg. Kun je er niet zoveel over kwijt, dan is het misschien geen eigen pagina waard.',
      },
      { type: 'heading', content: 'Over AI-teksten' },
      {
        type: 'paragraph',
        content:
          'Een taalmodel kan je helpen om te beginnen, maar wat er standaard uitkomt is vlak en algemeen. Het weet niet dat je in Oudkarspel zit, dat je klanten met een specifieke klacht komen of hoe jij het uitlegt. Gebruik het als hulp bij structuur, schrijf de inhoud zelf of laat iemand het doen die je gesproken heeft.',
      },
    ],
    relatedPosts: [
      'waarom-word-ik-niet-gevonden-in-google',
      'contactformulier-dat-aanvragen-oplevert',
      'hoeveel-paginas-heeft-mijn-website-nodig',
    ],
  },
  {
    slug: 'contactformulier-dat-aanvragen-oplevert',
    title: 'Een contactformulier dat wel aanvragen oplevert',
    category: 'Websites',
    excerpt:
      'Elk veld dat je toevoegt kost je aanvragen. Dit is wat je wel nodig hebt en wat weg kan.',
    metaDescription:
      'Waarom je contactformulier weinig aanvragen oplevert, en hoe je het inricht: minder velden, een duidelijke belofte en een bevestiging die vertrouwen geeft.',
    keywords:
      'contactformulier website, meer aanvragen website, formulier conversie, contactpagina verbeteren',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Een formulier lijkt een detail, maar het is de plek waar bezoek in werk verandert. Wij zien er twee soorten: het formulier met drie velden dat werkt, en het formulier met twaalf velden waar niemand aan begint.',
      },
      { type: 'heading', content: 'Vraag alleen wat je nodig hebt om te bellen' },
      {
        type: 'paragraph',
        content:
          'Naam, een manier om te reageren en de vraag. Dat is het. Postcode, bedrijfsgrootte en budget kun je in het gesprek vragen. Elk extra verplicht veld kost je aanvragen, en juist de twijfelaars vallen weg.',
      },
      { type: 'heading', content: 'Zet erbij wat er daarna gebeurt' },
      {
        type: 'paragraph',
        content:
          'Mensen vullen niets in als ze niet weten waar het heen gaat. Eén regel is genoeg: je krijgt binnen één werkdag antwoord van Rocco, en je zit tot niets verplicht. Dat haalt meer twijfel weg dan een mooiere knop.',
      },
      {
        type: 'list',
        items: [
          'Gebruik een knop die zegt wat er gebeurt, dus Vraag een prijsopgave aan in plaats van Verzenden.',
          'Zet je telefoonnummer ernaast. Een deel van je klanten belt liever en dat is prima.',
          'Toon na verzending een echte bevestiging op de pagina, geen lege pagina en geen sprong naar boven.',
          'Stuur direct een korte bevestigingsmail, zodat iemand weet dat het is aangekomen.',
        ],
      },
      {
        type: 'callout',
        content:
          'Test je eigen formulier één keer per maand vanaf je telefoon. Formulieren gaan stuk zonder dat iemand het merkt.',
      },
      { type: 'heading3', content: 'De stille killer: spamfilters' },
      {
        type: 'paragraph',
        content:
          'De meest voorkomende oorzaak van uitblijvende aanvragen is niet het formulier maar de aflevering. Als je site vanaf een verkeerd afzenderadres mailt, verdwijnen inzendingen in je spammap of komen ze nooit aan. Laat dit goed instellen en controleer het na elke verhuizing van je site.',
      },
    ],
    relatedPosts: [
      'teksten-voor-je-website-schrijven',
      'zakelijke-email-op-je-eigen-domein',
      'reviews-vragen-aan-klanten',
    ],
  },
  {
    slug: 'hoeveel-paginas-heeft-mijn-website-nodig',
    title: 'Hoeveel pagina\u2019s heeft mijn website nodig?',
    category: 'Websites',
    excerpt:
      'Niet zo veel als je denkt, en niet zo weinig als je hoopt. Een simpele rekenregel.',
    metaDescription:
      'Hoeveel pagina\u2019s heeft een zakelijke website nodig? Een simpele rekenregel op basis van je diensten, je doelgroepen en je werkgebied, met voorbeelden per bedrijfsgrootte.',
    keywords:
      'hoeveel pagina\u2019s website, website structuur, opbouw zakelijke website, sitemap opzetten',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Sommige ondernemers willen veertig pagina\u2019s omdat het compleet moet zijn. Anderen willen er drie omdat het overzichtelijk moet blijven. Beide keuzes worden zelden gemaakt op basis van wat de site moet doen.',
      },
      { type: 'heading', content: 'De rekenregel' },
      {
        type: 'paragraph',
        content:
          'Neem het aantal diensten waar je serieus werk uit wilt halen. Elk daarvan verdient een eigen pagina. Daar komen bij: een homepage, een pagina over jou of je team, een contactpagina en waar relevant een pagina met je werk. Heb je twee heel verschillende doelgroepen, dan verdubbelt het aantal dienstpagina\u2019s niet, maar krijgt elke doelgroep wel een eigen ingang.',
      },
      {
        type: 'list',
        items: [
          'Zzp met één dienst: één tot vier pagina\u2019s. Een onepager kan hier prima volstaan.',
          'Vakbedrijf met drie tot vijf diensten: zeven tot tien pagina\u2019s.',
          'Praktijk of kantoor met veel specialisaties: tien tot twintig pagina\u2019s, met een duidelijke groepering.',
          'Twee doelgroepen, bijvoorbeeld een uitzendbureau: twee ingangen met daaronder hun eigen pagina\u2019s.',
        ],
      },
      {
        type: 'callout',
        content:
          'Een pagina die geen eigen zoekvraag heeft en niets nieuws vertelt, kan beter een alinea op een andere pagina zijn.',
      },
      { type: 'heading', content: 'Waarom niet minder' },
      {
        type: 'paragraph',
        content:
          'Iemand die zoekt op een specifieke dienst wil op die dienst landen. Verwijs je hem naar een verzamelpagina, dan moet hij zelf zoeken en dat doet hij niet. Een eigen pagina per dienst is de enige manier om op die term gevonden te worden.',
      },
      { type: 'heading', content: 'Waarom niet meer' },
      {
        type: 'paragraph',
        content:
          'Elke pagina moet onderhouden worden en moet iets toevoegen. Twintig bijna identieke plaatspagina\u2019s of losse blogs zonder samenhang maken je site zwakker, niet sterker. Begin met de pagina\u2019s die je nu kunt vullen en breid uit naarmate je merkt waar vraag naar is.',
      },
    ],
    relatedPosts: [
      'wat-kost-een-website-laten-maken',
      'teksten-voor-je-website-schrijven',
      'website-fysiotherapiepraktijk-checklist',
    ],
  },
  {
    slug: 'website-sneller-maken',
    title: 'Je website sneller maken: wat echt helpt',
    category: 'Websites',
    excerpt:
      'Negen van de tien trage sites hebben hetzelfde probleem, en dat los je op zonder programmeur.',
    metaDescription:
      'Een trage website kost je bezoekers en posities. De maatregelen die echt verschil maken, van afbeeldingen op maat tot minder plug-ins, en wat je zelf kunt doen.',
    keywords:
      'website sneller maken, trage website, core web vitals, laadtijd website verbeteren',
    readingTime: 5,
    content: [
      {
        type: 'paragraph',
        content:
          'Snelheid is geen technische luxe. Duurt het langer dan drie seconden voordat er iets op het scherm staat, dan is een flink deel van je bezoekers al weg, en Google weegt het mee. Het goede nieuws: bij de meeste sites zit het probleem op één plek.',
      },
      { type: 'heading', content: 'Afbeeldingen zijn bijna altijd de oorzaak' },
      {
        type: 'paragraph',
        content:
          'Een foto rechtstreeks uit de camera is vaak vijf megabyte en vierduizend pixels breed, terwijl er twaalfhonderd pixels nodig zijn. Tien van die foto\u2019s op een pagina en je site is onbruikbaar op mobiel. Exporteer op de maat waarop de foto getoond wordt, kies een modern formaat en laat afbeeldingen onder de eerste schermvulling pas laden als iemand ernaartoe scrolt.',
      },
      { type: 'heading', content: 'Daarna: minder onderdelen' },
      {
        type: 'list',
        items: [
          'Verwijder plug-ins die je niet gebruikt. Elke actieve plug-in laadt code mee.',
          'Beperk het aantal lettertypen tot één of twee, en laad alleen de gewichten die je gebruikt.',
          'Zet geen video op de achtergrond van je homepage. Dat is de duurste seconde die je kunt kopen.',
          'Wees zuinig met trackers. Elk extra script vertraagt de hele pagina.',
        ],
      },
      {
        type: 'callout',
        content:
          'Meet altijd op mobiel via een 4G-verbinding. Op je eigen glasvezel is bijna elke site snel.',
      },
      { type: 'heading3', content: 'Wat hosting eraan doet' },
      {
        type: 'paragraph',
        content:
          'Goede hosting maakt een trage site niet snel, maar slechte hosting maakt een snelle site langzaam. Zit je op een pakket van een paar euro per maand waar duizend sites op dezelfde server staan, dan loop je tegen een grens aan die je met optimalisatie niet wegwerkt. Caching en een fatsoenlijke server halen daarnaast makkelijk een seconde weg.',
      },
    ],
    relatedPosts: [
      'waarom-word-ik-niet-gevonden-in-google',
      'website-onderhoud-waarom-nodig',
      'website-laten-maken-of-zelf-doen',
    ],
  },
]
